/**
 * Ryan O'Dowd
 * 2021-06-28
 * © Copyright 2021 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, fonts}) => {
  return {
    container: {
      flex: 1,
      fontFamily: fonts.primary,
      backgroundColor: '#00000000',
      textAlign: 'left',
      fontSize: globalScale * 16,
    },
    textStyles: {
      marginVertical: globalScale * 7, // @TODO: to match select styles...don't like that it's 7
      paddingLeft: globalScale * 8,
    },
  };
};

export default getStyles;
